import { render, staticRenderFns } from "./NewDateFields.vue?vue&type=template&id=f35c89ca&scoped=true&"
import script from "./NewDateFields.vue?vue&type=script&lang=js&"
export * from "./NewDateFields.vue?vue&type=script&lang=js&"
import style0 from "./NewDateFields.vue?vue&type=style&index=0&id=f35c89ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c89ca",
  null
  
)

export default component.exports